module.exports = __webpack_public_path__ + "img/947899573.1a5d952b.jpg";